import axios from 'axios';

const baseURL = process.env.REACT_APP_API_URL
const apiClient = axios.create({
    baseURL,
    withCredentials: true,
    timeout: 5000 // 5 seconds
});

interface AuthURLResponse {
    authURL?: string
}

interface LoginCallbackResponse {
    sessionID: string
    name: string
    url: string
    photo: string
}

export const fetchAuthURL = async (
    loginURL: string
): Promise<string> => {
    try {
        const response = await apiClient.post<AuthURLResponse>(
            "/login-init",
            { me: loginURL }
        );

        const authURL = response.data && response.data.authURL;

        if (authURL) {
            return Promise.resolve(authURL);
        }

        return Promise.reject(
            new Error('No authURL returned in API reponse')
        );

    } catch (err) {
        return Promise.reject(
            new Error('HTTP request failed')
        );
    }
};

export const callbackLogin = async (): Promise<LoginCallbackResponse> => {

    const params = new URLSearchParams(location.search);
    const state = params.get("state");
    const code = params.get("code");

    try {
        const response = await apiClient.post<LoginCallbackResponse>(
            "/login-callback",
            { code, state }
        );

        const name = response.data && response.data.name;
        const url = response.data && response.data.url;
        const photo = response.data && response.data.photo;
        const sessionID = response.data && response.data.sessionID;
        return Promise.resolve({name, url, photo, sessionID});
    } catch (err) {
        return Promise.reject(
            new Error('HTTP request failed')
        );
    }
};

interface LoginCheckResponse {
    name: string
    url: string
    photo: string
}

export const loginCheck = async (): Promise<LoginCheckResponse> => {

    try {
        const response = await apiClient.get<LoginCheckResponse>(
            "/session-check",
        );

        const name = response.data && response.data.name;
        const url = response.data && response.data.url;
        const photo = response.data && response.data.photo;
        return Promise.resolve({name, url, photo});

    } catch (err) {
        return Promise.reject(
            new Error('HTTP request failed')
        );
    }
};
